module.exports = __webpack_public_path__ + "img/1.e1eb7b9f.jpg";